import React from "react";
import { Redirect } from "react-router-dom";
import { BarLoader } from "react-spinners";

export default function() {
  const { errorMessage, username, password, loggedIn, loggingIn } = this.state;
  return (
    <div className="index_wrap">
    <div className="container splash">
      {loggedIn && <Redirect to="/machine" />}
      {errorMessage !== "" && <p>{errorMessage}</p>}
      <img src="logo-red.png" className="splash-logo" alt="RugDoctor" />
      <div>
      <label htmlFor="login_username" className="login_input_label">User name</label>
      <input
        id="login_username"
        onChange={this._change("username")}
        value={username}
        placeholder="Username"
      />
      </div>
      <div>
      <label htmlFor="login_pw" className="login_input_label">Password</label>
      <input
        id="login_pw"
        onChange={this._change("password")}
        value={password}
        type="password"
        placeholder="Password"
      />
      </div>
      <button onClick={this._login}>
        {loggingIn ? (
          <div className="button-loader">
            <BarLoader width={200} height={4} color={"white"} />
          </div>
        ) : (
          "Submit"
        )}
      </button>
    </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/screens/login/view.js